/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepsJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEPS_JOB_EVENT_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepsJobEvent';
export const ixcSweepsClearingV1SweepsJobEventEntity = new schema.Entity<IxcSweepsClearingV1SweepsJobEvent>(IXC_SWEEPS_CLEARING_V1_SWEEPS_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepsJobEvent) => `${entity.metadata?.eventId}` });

